<h2 mat-dialog-title class="dialog-title">
    Approve {{ userName }} on {{ positionName }} Post
    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <!-- User & Position Header -->
    <div class="assignment-header">
        <div class="user-info">
            <div class="user-avatar" *ngIf="userAvatarUrl" [class.is-online]="isUserOnline">
                <img [src]="userAvatarUrl" [alt]="userName" style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;">
                <span class="online-dot" *ngIf="isUserOnline" title="Online now"></span>
            </div>
            <div class="user-avatar placeholder" *ngIf="!userAvatarUrl" [class.is-online]="isUserOnline">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px;">person</mat-icon>
                <span class="online-dot" *ngIf="isUserOnline" title="Online now"></span>
            </div>
            <div class="user-details">
                <span class="user-name">{{ userName }}</span>
                <span class="position-label">
                    <mat-icon class="inline-icon">location_on</mat-icon>
                    {{ positionName }}
                </span>
            </div>
        </div>
        <div class="approval-meta">
            <span class="meta-item">
                <mat-icon class="inline-icon">person</mat-icon>
                Requested by: {{ requestedByDisplay }}
            </span>
            <span class="meta-item" *ngIf="approvals.length > 1">
                <mat-icon class="inline-icon">layers</mat-icon>
                {{ approvals.length }} pending requests bundled
            </span>
        </div>
    </div>

    <!-- Hat Selection -->
    <div class="hat-selection-section">
        <h3>
            <mat-icon>school</mat-icon>
            Hats to assign now ({{ selectedHatCount }}/{{ hatItems.length }})
        </h3>
        <p class="section-hint">
            These hats are linked to the post and were proposed for this user. Tick the ones to assign now
            and untick any you don&rsquo;t want to give yet &mdash; you can always add them later via
            <strong>Manage Hats on Post</strong>. Approving confirms the user on the post regardless of how
            many hats are ticked.
        </p>

        <div class="hat-list">
            <div *ngFor="let hat of hatItems" class="hat-item" [class.deselected]="!hat.selected">
                <mat-checkbox [(ngModel)]="hat.selected" [disabled]="isProcessing">
                    <span class="hat-name">{{ hat.name }}</span>
                    <span *ngIf="hat.isSpecialRights" class="special-rights-badge">Special Rights</span>
                </mat-checkbox>

                <div class="hat-details" *ngIf="hat.selected">
                    <div *ngIf="hat.securityGroupNames.length" class="detail-row">
                        <span class="detail-label">Security Groups:</span>
                        <span class="sg-chip" *ngFor="let sg of hat.securityGroupNames">{{ sg }}</span>
                    </div>
                    <div *ngIf="hat.featureNames.length" class="detail-row">
                        <span class="detail-label">Features:</span>
                        <span class="feature-chip" *ngFor="let f of hat.featureNames">{{ f }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Access Preview -->
    <div class="access-preview" *ngIf="allFeatures.length > 0">
        <h3>
            <mat-icon>preview</mat-icon>
            Access Preview
        </h3>
        <p class="section-hint">Features the user will gain from the ticked hats.</p>
        <div class="feature-list">
            <span class="feature-chip approved" *ngFor="let f of allFeatures">{{ f }}</span>
        </div>
    </div>

    <!-- Reject Confirmation -->
    <div class="reject-section" *ngIf="showRejectConfirm">
        <h3>
            <mat-icon>block</mat-icon>
            Reject this user on the post
        </h3>
        <p class="section-hint">
            Rejecting cancels all pending hat requests for this user on this post. The user will not be
            confirmed on the post and any pending hats will be removed.
        </p>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Reason for rejection (optional)</mat-label>
            <textarea matInput [(ngModel)]="rejectionReason" rows="3" [disabled]="isProcessing"></textarea>
        </mat-form-field>
        <div class="reject-actions">
            <button mat-button (click)="onCancelReject()" [disabled]="isProcessing">Cancel</button>
            <button mat-raised-button color="warn" (click)="onReject()" [disabled]="isProcessing">
                <mat-icon>block</mat-icon>
                Confirm Rejection
            </button>
        </div>
    </div>

    <!-- Failure surface — approve/reject must never fail silently -->
    <div class="error-banner" *ngIf="errorMessage" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close [disabled]="isProcessing">Cancel</button>
    <button mat-raised-button color="warn"
            (click)="onReject()"
            [disabled]="isProcessing || showRejectConfirm"
            *ngIf="!showRejectConfirm">
        <mat-icon>block</mat-icon>
        Reject
    </button>
    <button mat-raised-button color="primary"
            (click)="onApprove()"
            [disabled]="isProcessing">
        <mat-spinner *ngIf="isProcessing" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
        <mat-icon *ngIf="!isProcessing">check_circle</mat-icon>
        {{ approveButtonLabel }}
    </button>
</mat-dialog-actions>
